<template>
  <div
    class="fz-Nesspresso col__black app"
    style="opacity: 0"
    :class="{ init: inited }"
  >
    <Landing />
  </div>
</template>

<script>
import { Landing } from "./components/";
// import $ from "jquery";

export default {
  name: "app",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      langRender: window.__LANG__,
      clicked: false,
      showTnc: false,
      inited: false,
    };
  },
  mounted() {
    this.inited = true;
    // $("body").scrollTop(0);
    // $("html").scrollTop(0);
  },

  components: {
    // HomeBanner,
    // HomeCups,
    // HomeIncluded,
    // HomeMachine,
    // HomeHowTo,
    // renderForCartButton,
    // HomeVideo,
    // TNC,
    // Icons,
    Landing,
  },

  computed: {
    lang() {
      if (this.langRender) {
        return this.langRender;
      }

      if (!window) {
        return;
      }

      return window.location.href.includes("en") ? "en" : "tc";
    },
  },
  methods: {
    handleclick() {
      this.clicked = !this.clicked;
    },
  },

  watch: {
    showTnc(val) {
      const element = document.getElementsByTagName("html");
      if (!element || element.length == 0) {
        return;
      }
      if (val) {
        element[0].classList.add("sticky");
      } else {
        element[0].classList.remove("sticky");
      }
    },
  },
};
</script>

<style lang="scss">
@import "~/scss/include/_commonInclude.scss";
.content .app {
  transition: opacity 0.25s linear;

  &.init {
    opacity: 1 !important;
  }
}

.freeze {
  overflow: hidden;
  width: 100%;
}
</style>
